var _defs, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-logo",
    height: "100%",
    width: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 391.807 383.034",
    xmlSpace: "preserve",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    height: 36,
    id: "Image",
    width: 37,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAkCAYAAAAOwvOmAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABc0lEQVR4nM2X63rCIAyG5SZsrd1N7+A23XZvq7NeBnZU0tKEBcpp/WMN3xNe8xEQsX28SrG5P/Dy+8gxZMTsOrtW4hCjE9UAZU7ETYKBXGE4rR4T1dMdyhkmUmUIGAiPUAWtIsYHqF4G2bQChq1c/dwTGU0YbhIWhgNa5MFQsYEYq8g8CiqhVV4wuvvql3ml/Fo8hlVUrgHqIqkBb5iAyix1APVfgNTH7nCR1IBXkojrD0MlXDde4ABVyCpKJ3avP2i0FAx8n0MlhfHQKqjcleG0onnD9qXqKledCRW4E4fCaN0IVdAqSiea93P0Y8ZXt9SK/fFsUaWHsa1ZDJXZKko3QSX4xatOCYAqaBVUZx7anzojQ+7FTl2EAarE3mS7mSuo7MeIEZtgINR+dNG6z7kyFhgdm6AKWbWMqe5rP7/d/k+tgKErY4fRLwgqu1WEDqCy2MTAwL3z4QvblwTIYhXSkVCBu/FfVrFAuooAVcgqCvoGh8DnDYPeGb0AAAAASUVORK5CYII="
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 383.034,
    width: 391.807,
    x: 0,
    y: 0,
    className: "svg-elem-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Sin-t\\xEDtulo"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "nonzero",
    id: "ClipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M947.511 686.303L929.049 704.083L947.511 721.862L965.974 704.083L947.511 686.303Z",
    className: "svg-elem-2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ClipPath)"
  }, /*#__PURE__*/React.createElement("use", {
    opacity: 1,
    transform: "matrix(1 0 0 1 929 686)",
    xlinkHref: "#Image"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.998 140.806L213.258 115.511L195.449 134.438L219.399 158.928C224.918 164.613 227.892 172.109 227.771 180.031C227.65 187.95 224.457 195.347 218.773 200.861L195.903 222.886L177.185 240.912L67.2138 346.814C63.3197 350.151 58.3915 351.985 53.3041 351.985C41.861 351.985 32.5196 343.074 31.9417 331.656L31.8717 293.383L31.8717 166.746L31.9062 139.304C32.5824 100.849 64.3944 69.5802 102.864 69.5802C121.366 69.5802 138.964 77.9939 158.215 96.0502L162.827 101.078L177.288 115.866L195.101 96.9475L181.824 83.3733L177.03 78.144L176.368 77.4728C152.201 54.688 128.157 43.6119 102.864 43.6119C77.2446 43.6119 53.0881 53.512 34.8422 71.4902C16.6207 89.4431 6.35667 113.409 5.93898 138.972L5.90349 166.729L5.90349 293.407L5.97446 331.984L5.9846 332.485C7.0187 357.982 27.8042 377.954 53.3041 377.954C64.7867 377.954 75.8831 373.762 84.5483 366.154L84.7723 365.958L195.903 258.938L214.621 240.912L236.808 219.546L236.841 219.514C247.51 209.169 253.511 195.286 253.736 180.425C253.961 165.564 248.385 151.507 237.998 140.806",
    fill: "#004cdc",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#004cdc",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2.89639,
    className: "svg-elem-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.867 139.166L385.865 138.973C385.448 113.409 375.184 89.4429 356.963 71.49C338.717 53.5128 314.56 43.6117 288.942 43.6117C259.281 43.6117 238.578 53.1701 215.21 77.6845L199.255 92.5371L195.102 96.9473L177.289 115.866L153.696 140.921C143.393 151.576 137.845 165.601 138.07 180.425C138.295 195.286 144.296 209.169 154.964 219.514L177.184 240.912L195.903 222.886L173.032 200.862C167.35 195.347 164.155 187.95 164.035 180.032C163.914 172.109 166.888 164.614 172.406 158.928L195.45 134.438L213.257 115.511L217.265 111.25L233.192 96.4241L233.761 95.8605C252.417 76.2114 266.341 69.58 288.942 69.58C327.408 69.58 359.218 100.847 359.899 139.299L359.935 166.729L359.935 304.363L359.864 331.651C359.288 343.072 349.946 351.985 338.501 351.985C333.416 351.985 328.485 350.151 324.592 346.814L214.621 240.912L195.903 258.938L306.819 365.75L307.258 366.154C315.924 373.762 327.018 377.953 338.501 377.953C364.001 377.953 384.786 357.982 385.82 332.487L385.903 304.397L385.903 166.712L385.867 139.166Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#004cdc",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2.89639,
    className: "svg-elem-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.547 34.5348C166.547 18.2679 179.734 5.08004 196.002 5.08004C212.27 5.08004 225.456 18.2679 225.456 34.5348C225.456 50.8027 212.27 63.9906 196.002 63.9906C179.734 63.9906 166.547 50.8027 166.547 34.5348",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#004cdc",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2.89639,
    className: "svg-elem-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.748 348.499C179.48 348.499 166.292 361.686 166.292 377.954L225.203 377.954C225.203 361.686 212.015 348.499 195.748 348.499",
    fill: "#004cdc",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#004cdc",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2.89639,
    className: "svg-elem-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1515.64 29.4327L1970.05 29.4327L1970.05 1273.62L1515.64 1273.62L1515.64 29.4327Z",
    fill: "#0058ff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 0,
    className: "svg-elem-7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05f9ccd3077eb2d418e78ce1c06a07c2.svg";
export { ForwardRef as ReactComponent };